import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import {
  getActualCategory,
  getHasSearchListResults,
  getIsSearchListLoaded,
} from '@bridebook/web/app-basic/lib/search/selectors';
import SearchListPagination from './search-list-pagination';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { PropsWithChildren, memo } from 'react';
import SearchNoResults from '@bridebook/web/app-shared/components/search-no-results/search-no-results';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { ISearchPageQuery } from '@bridebook/web/app-shared/lib/search/types';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';

interface IProps {
  fullQuery: ISearchPageQuery;
  totalPages: number;
  isNoResultsSearch?: boolean;
  facetsParams: string[];
}

const SearchList = ({
  fullQuery,
  totalPages,
  children,
  isNoResultsSearch,
  facetsParams,
}: PropsWithChildren<IProps>) => {
  const hasSearchListResults = useSelector(getHasSearchListResults);
  const isSearchListLoaded = useSelector(getIsSearchListLoaded);
  const actualCategory = useSelector(getActualCategory);
  const filters = useSelector(({ search }) => search.filters);
  const isMobile = useSelector(getIsMobile);
  const market = useMarket();
  const prettyCategory = prettySupplierCategory({
    isLoggedIn: false,
    slug: actualCategory,
    amount: 2,
    addWedding: false,
    capitalize: false,
    market,
  });

  return (
    <div className="bss" id="search-list-results">
      {!hasSearchListResults && isSearchListLoaded && (
        <SearchNoResults
          filters={filters}
          category={prettyCategory}
          isMobile={isMobile}
          isLoggedOut
        />
      )}
      <div className="bst">{children}</div>
      {!isNoResultsSearch && totalPages > 0 && (
        <SearchListPagination fullQuery={fullQuery} facetsParams={facetsParams} />
      )}
    </div>
  );
};
export default memo(SearchList);
